import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-payment-overview',
  templateUrl: './org-payment-overview.component.html',
  styleUrls: ['./org-payment-overview.component.less'],
})
export class OrgPaymentOverviewComponent {
  constructor() {}
}
